module.exports = __webpack_public_path__ + "static/img/login_bg.80c3eb1e.jpg";